import loadable from '@loadable/component';

const StoryblokAccordion = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/Accordion/StoryblokAccordion'),
);
const StoryblokAccordionItem = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './components/Accordion/StoryblokAccordionItem'
    ),
);
const StoryblokArchiveBlog = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './components/ArchiveBlog/StoryblokArchiveBlog'
    ),
);
const StoryblokArchiveBlogCategory = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './components/ArchiveBlog/StoryblokArchiveBlogCategory'
    ),
);
const StoryblokCarousel = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/Carousel/StoryblokCarousel'),
);
const StoryblokCarouselListingSlide = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './components/Carousel/StoryblokCarouselListingSlide'
    ),
);
const StoryblokCarouselPartnerSlide = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './components/Carousel/StoryblokCarouselPartnerSlide'
    ),
);
const StoryblokCarouselReviewSlide = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './components/Carousel/StoryblokCarouselReviewSlide'
    ),
);
const StoryblokCarouselTestimonialSlide = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './components/Carousel/StoryblokCarouselTestimonialSlide'
    ),
);
const StoryblokSearchCarousel = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './components/Carousel/StoryblokSearchCarousel'
    ),
);
const StoryblokLocationCard = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './components/LocationCard/StoryblokLocationCard'
    ),
);
const StoryblokLocationCardGroup = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './components/LocationCard/StoryblokLocationCardGroup'
    ),
);
const StoryblokButton = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokButton'),
);
const StoryblokChip = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokChip'),
);
const StoryblokDivider = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokDivider'),
);
const StoryblokImage = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokImage'),
);
const StoryblokListingCard = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokListingCard'),
);
const StoryblokNewsletter = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokNewsletter'),
);
const StoryblokPartnerCard = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokPartnerCard'),
);
const StoryblokReviewCard = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokReviewCard'),
);
const StoryblokRichText = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokRichText'),
);
const StoryblokSearchResult = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokSearchResult'),
);
const StoryblokStoreButton = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokStoreButton'),
);
const StoryblokTestimonialCard = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokTestimonialCard'),
);
const StoryblokTitle = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokTitle'),
);
const StoryblokBlogPostPageComponent = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './contentType/StoryblokBlogPostPageComponent'
    ),
);
const StoryblokPageComponent = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './contentType/StoryblokPageComponent'),
);
const StoryblokChangedAt = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './dataSourceComponents/StoryblokChangedAt'),
);
const StoryblokGridItem = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './layout/StoryblokGridItem'),
);
const StoryblokGridSection = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './layout/StoryblokGridSection'),
);
const StoryblokPassPreset = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './presets/StoryblokPassPreset'),
);
const StoryblokDestionationsPreset = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './presets/StoryblokDestinationsPreset'),
);
const StoryblokHerosearchPreset = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './presets/StoryblokHerosearchPreset'),
);
const StoryblokCountriesWomoPreset = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './presets/Countries Preset/StoryblokCountriesWomoPreset'
    ),
);
const StoryblokCountriesTentPreset = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './presets/Countries Preset/StoryblokCountriesTentPreset'
    ),
);
const StoryblokCountriesCaravanPreset = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './presets/Countries Preset/StoryblokCountriesCaravanPreset'
    ),
);
const StoryblokRegionsWomoPreset = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './presets/Regions Preset/StoryblokRegionsWomoPreset'
    ),
);
const StoryblokRegionsTentPreset = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './presets/Regions Preset/StoryblokRegionsTentPreset'
    ),
);
const StoryblokRegionsCaravanPreset = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './presets/Regions Preset/StoryblokRegionsCaravanPreset'
    ),
);
const StoryblokCitiesWomoPreset = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './presets/Cities Preset/StoryblokCitiesWomoPreset'
    ),
);
const StoryblokCitiesTentPreset = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './presets/Cities Preset/StoryblokCitiesTentPreset'
    ),
);
const StoryblokCitiesCaravanPreset = loadable(() =>
  import(
    /* webpackChunkName: "StoryblokComponents"*/ './presets/Cities Preset/StoryblokCitiesCaravanPreset'
    ),
);
const StoryblokPassTierCardsPreset = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './presets/StoryblokPassTierCardsPreset'),
);
const StoryblokPassBenefitsPreset = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './presets/StoryblokPassBenefitsPreset'),
);
const StoryblokHeyFlow = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './components/StoryblokHeyFlow'),
);

const StoryblokFormPreset = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './presets/StoryblokFormPreset'),
);
const StoryblokFlexPassPreset = loadable(() =>
  import(/* webpackChunkName: "StoryblokComponents"*/ './presets/StoryblokFlexPassPreset'),
);

const StoryblokComponents = {
  // Content Type
  page: StoryblokPageComponent,
  blog_post: StoryblokBlogPostPageComponent,
  // Layout
  grid_section: StoryblokGridSection,
  grid_item: StoryblokGridItem,
  // Components
  accordion: StoryblokAccordion,
  archive_blog: StoryblokArchiveBlog,
  button: StoryblokButton,
  carousel: StoryblokCarousel,
  carousel_search: StoryblokSearchCarousel,
  category: StoryblokArchiveBlogCategory,
  chip: StoryblokChip,
  divider: StoryblokDivider,
  image: StoryblokImage,
  listing_card: StoryblokListingCard,
  location_cards_group: StoryblokLocationCardGroup,
  partner_card: StoryblokPartnerCard,
  rich_text: StoryblokRichText,
  review_card: StoryblokReviewCard,
  search_result: StoryblokSearchResult,
  testimonial_card: StoryblokTestimonialCard,
  title: StoryblokTitle,
  newsletter: StoryblokNewsletter,
  storebutton: StoryblokStoreButton,
  heyflow: StoryblokHeyFlow,
  // Presets for marketing team
  pass_preset: StoryblokPassPreset,
  herosearch_preset: StoryblokHerosearchPreset,
  destinations_preset: StoryblokDestionationsPreset,
  countries_womo_preset: StoryblokCountriesWomoPreset,
  countries_tent_preset: StoryblokCountriesTentPreset,
  countries_caravan_preset: StoryblokCountriesCaravanPreset,
  regions_womo_preset: StoryblokRegionsWomoPreset,
  regions_tent_preset: StoryblokRegionsTentPreset,
  regions_caravan_preset: StoryblokRegionsCaravanPreset,
  cities_womo_preset: StoryblokCitiesWomoPreset,
  cities_tent_preset: StoryblokCitiesTentPreset,
  cities_caravan_preset: StoryblokCitiesCaravanPreset,
  pass_tier_cards_preset: StoryblokPassTierCardsPreset,
  pass_benefits_preset: StoryblokPassBenefitsPreset,
  form_preset: StoryblokFormPreset,
  flex_pass_preset: StoryblokFlexPassPreset,
  // Items for components
  accordion_item: StoryblokAccordionItem,
  listing_slide: StoryblokCarouselListingSlide,
  location_card: StoryblokLocationCard,
  partner_slide: StoryblokCarouselPartnerSlide,
  review_slide: StoryblokCarouselReviewSlide,
  testimonial_slide: StoryblokCarouselTestimonialSlide,
  // Data source components
  changed_at_dates: StoryblokChangedAt,
};

export default StoryblokComponents;
